export default __webpack_public_path__ + "static/media/TarantiaCommonDistrict.a5dfca24.jpg";